<template>
  <div
    v-on="$listeners"
    class="app-card-button"
    :class="{
      active,
    }"
    :style="{
      color: colors.text,
      'background-color': colors.background,
    }"
  >
    <slot />
  </div>
</template>

<script>
import { getTextColor } from '@/helpers'

export default {
  name: 'AppCardButton',

  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    active: {
      immediate: true,
      handler: 'scrollToMe',
    },
  },

  computed: {
    colors() {
      const backgroundColor = this.$attrs.backgroundColor ?? this.$attrs.color
      const textColor =
        this.$attrs.textColor ??
        (backgroundColor ? getTextColor(backgroundColor) : undefined)

      return {
        background: backgroundColor,
        text: textColor,
      }
    },

    buttonCardsComponent() {
      return this.findComponentInParent('AppCardButtons')
    },
  },

  methods: {
    scrollToMe(active) {
      if (active === false) return

      const buttonCardsComponent = this.buttonCardsComponent

      if (buttonCardsComponent) buttonCardsComponent.scrollToCard(this.$el)
    },
  },
}
</script>

<style lang="scss" scoped>
@use 'sass:math';

@import '@/styles/settings.scss';
@import '@/styles/functions.scss';

.app-card-button {
  $backgroundColor: rgba(255, 255, 255, 0.25);
  $textColor: #fff;
  $transitionDuration: 0.5s;
  $padding: math.div($defaultPadding, 2);
  $margin: 0.5rem;

  background-color: $backgroundColor;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: max-content;
  min-width: 120px;
  padding: $padding;
  border-radius: $defaultBorderRadius;
  margin-top: $margin;
  margin-left: $margin;
  font-size: 80%;
  line-height: 120%;
  transition: color $transitionDuration, background-color $transitionDuration;

  &.active {
    $backgroundColor: #fff;
    $textColor: get-text-color($backgroundColor);
    background-color: $backgroundColor;
    color: $textColor;
  }

  > * {
    margin-top: 0.5rem;

    &:first-child {
      margin-top: 0;
    }
  }
}
</style>
